import { Navigate, Route, Routes } from 'react-router-dom-v5-compat';

import { ProjectLinkAccountGate } from './services/ProjectLinkAccountGate';
import { ReviewerDashboardPage } from './views/ReviewerDashboardPage';
import { ReviewerProjectPage } from './views/ReviewerProjectPage';
import { ReviewerRoute } from './views/ReviewerRoute';
import { renderAccountPublicRoutes } from './publicRoutes';
import { ROUTES } from './routes';

/** A reviewer's account has only the shared projects; every other path goes to their list. */
export const ReviewerRouting = () => (
  <Routes>
    {renderAccountPublicRoutes()}

    <Route
      path={`${ROUTES.PROJECTS}/:projectId`}
      element={
        <ProjectLinkAccountGate>
          <ReviewerRoute>
            <ReviewerProjectPage />
          </ReviewerRoute>
        </ProjectLinkAccountGate>
      }
    />
    <Route
      path={ROUTES.ROOT}
      element={
        <ReviewerRoute>
          <ReviewerDashboardPage />
        </ReviewerRoute>
      }
    />
    <Route
      path="*"
      element={
        <Navigate
          to={ROUTES.ROOT}
          replace
        />
      }
    />
  </Routes>
);
